import Vue from 'vue';
import Router from 'vue-router';
import Root from '@/components/Root';
import Login from '@/components/Login';
import Serial from '@/components/Serial';
import Dictionary from '@/components/dictionary/Dictionary';
import CarrierActivation from '@/components/CarrierActivation';

Vue.use(Router);

export default new Router({
  routes: [
    {
      // メイン画面
      path: '/',
      name: 'Root',
      component: Root,
    },
    {
      // ログイン画面
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      // シリアル入力画面
      path: '/activate',
      name: 'Serial',
      component: Serial,
    },
    {
      // 辞書画面
      path: '/dictionary',
      name: 'Dictionary',
      component: Dictionary,
    },
    {
      // キャリア利用開始画面
      path: "/carrieractivation",
      name: "CarrierActivation",
      component: CarrierActivation
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js